import { render, staticRenderFns } from "./CardLayoutSwitch.vue?vue&type=template&id=769c54a4&scoped=true&"
import script from "./CardLayoutSwitch.vue?vue&type=script&lang=ts&"
export * from "./CardLayoutSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./CardLayoutSwitch.vue?vue&type=style&index=0&id=769c54a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769c54a4",
  null
  
)

component.options.__file = "CardLayoutSwitch.vue"
export default component.exports